// Styles for ConsentCheckListItem go here.
import { toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledConsentsListItem = styled.div`
  &.m-consent-list {
    margin: ${toRem(32)} 0;
    .legal-text-link {
      font-size: ${toRem(14)};
      font-weight: 500;
    }
    a {
      font-size: ${toRem(14)};
      font-weight: bold;
    }
  }

  &.m-china-consents {
    &:first-of-type {
      .legal-text-link {
        font-size: ${toRem(16)};
        font-weight: bold;
      }
    }
  }

  .term-link-accordion-button {
    font-size: ${toRem(14)};
    font-weight: bold;
    white-space: nowrap;
    background: none;
  }
`;
